<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $tc('add') }} {{ $tc('bookingusercategory', 1) }}</div>
      <router-link
        class="btn-blue"
        to="booking-user-category"
      >{{ $tc('bookingusercategory', 2) }} {{ $tc('list',2) }}</router-link>
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in BookingUserCategories"
          :key="index"
          v-if="item.fieldname !== 'buc_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'buc_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1)}}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has(item.fieldname)"
              >{{ errors.first(`${item.fieldname}`) }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'buc_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t('active') }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="onFinalSubmit(false)">{{ $t('save') }}</button>
          <button
            @click.prevent.stop="onFinalSubmit(true)"
            type="submit"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button class="btn-black" @click.prevent.stop="onResetForm()">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="booking-user-category"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import BookingUserCategories from "@/helper/formJSONMaster/BookingUserCategories";

export default {
  data() {
    return {
      BookingUserCategories: BookingUserCategories.ms_booking_user_categories,
      // v-validate="'required|email'"
      submitted: false,
      Methods: BookingUserCategories.Methods
    };
  },
  beforeMount() {
    this.onResetForm();
  },
  mounted() {
    console.log("BookingUserCategories :", BookingUserCategories);
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    onResetForm: function() {
      this.BookingUserCategories.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let body = this.getRequestBody(
            "POST",
            this.BookingUserCategories,
            this.Methods
          );

          MasterService.GlobalRequest(body)
            .then(response => {
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                this.$router.push({
                  path: "/master/booking-user-category"
                });
                // if (redirect) {
                //   this.$router.push({
                //     path: "/master/booking-user-category"
                //   });
                // }
              } else {
                // Show Error:
                // data.message
                this.$toasted.show(data.message);
                console.log("data.message :", data.message);
              }
            })
            .catch(error => {
              // Catch Error:
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BookingUserCategoryComponents/addBookingUserCategory.vue